import React, { Component } from 'react';
import { Rect, Text, Group } from 'react-konva';

export class LineInformationComponentCanvas extends Component {
    render() {
        const { component, isSelected, dimentionsRatio, draggable } = this.props;

        const componentSecundaryColor = "#F5F5F5";
        const componentWidth = component.width * dimentionsRatio;
        const componentHeight = component.height * dimentionsRatio;

        const componentWidthRatio = component.width / 1200.0 * dimentionsRatio;
        const componentHeightRatio = component.height / 200.0 * dimentionsRatio;

        const height = 100 * componentHeightRatio;
        const smallWidth = 200 * componentWidthRatio;
        const bigWidth = 850 * componentWidthRatio;

        const firstElementPosX = component.drawPositionX + 50 * componentWidthRatio;
        const secondElementPosX = component.drawPositionX + 300 * componentWidthRatio;

        const rectElementPosY = component.drawPositionY + 50 * componentHeightRatio;
        const fontElementPoxY = rectElementPosY + height / 5.0;

        let fontSize = height * 0.85;
        if (6.5 * fontSize > componentWidth) {
            fontSize = componentWidth / 6.5;
        }

        return (
            <Group
                offsetX={component.offsetX}
                offsetY={component.offsetY}
                draggable={draggable}
                onDragEnd={this.props.onDragEnd}
                onClick={this.props.onComponentClick ? () => this.props.onComponentClick(component.internalId) : null} >
                <Rect x={component.drawPositionX}
                    y={component.drawPositionY}
                    width={componentWidth}
                    height={componentHeight}
                    strokeWidth={isSelected ? 3 : 1}
                    stroke={isSelected ? "#6699ff" : "black"}
                    fill={component.color} />

                <Group>
                    <Rect x={firstElementPosX}
                        y={rectElementPosY}
                        width={smallWidth}
                        height={height}
                        strokeWidth={1}
                        stroke="black"
                        fill={componentSecundaryColor} />
                    <Text text="X"
                        fontSize={fontSize}
                        x={firstElementPosX + 1}
                        y={fontElementPoxY}
                        fill="black" />
                </Group>
                <Group>
                    <Rect x={secondElementPosX}
                        y={rectElementPosY}
                        width={bigWidth}
                        height={height}
                        strokeWidth={1}
                        stroke="black"
                        fill={componentSecundaryColor} />
                    <Text text="Linha"
                        fontSize={fontSize}
                        x={secondElementPosX + 1}
                        y={fontElementPoxY}
                        fill="black" />
                </Group>
            </Group>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/layoutConfigurations/componentCanvas/LineInformationComponentCanvas.js